import * as React from 'react';

import { Route, Routes } from 'react-router-dom';

import ServiceModeModal from 'components/service-mode-modal';
import { relativeRoutes } from 'utils/routing';

export const ServiceModeRoutes: React.VFC = () => {
  return (
    <Routes>
      <Route path={relativeRoutes.serviceMode} element={<ServiceModeModal />} />
    </Routes>
  );
};
